import type { Report } from "./hooks/useReports";

export const formatDate = (dateString: string): string => {
  try {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      throw new Error("Invalid date");
    }

    return date.toLocaleDateString("de-DE", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    console.warn(`Failed to format date: ${dateString}`);
    return dateString; // Fallback to original string if parsing fails
  }
};

export const getReportDisplayName = (report: Report): string => {
  // Build name from first and last name if available
  if (report.firstName || report.lastName) {
    const fullName =
      `${report.firstName || ""} ${report.lastName || ""}`.trim();
    if (fullName) {
      return fullName;
    }
  }

  if (report.fileName) {
    return report.fileName;
  }

  return "";
};

export const isReportPending = (report: Report): boolean => {
  return !report.downloadedAt;
};
